import { numberFormatter } from "../../../gridFormatters";

export const highPerformingHostsDefs = [
  {
    field: "host_name",
    headerName: "Host Name",
  },
  {
    field: "allocated",
    headerName: "Allocated Size",
    cellRenderer: numberFormatter
  },
  {
    field: "iops",
    headerName: "IOPS",
    cellRenderer: numberFormatter
  },
  {
    field: "latency",
    headerName: "Latency",
    cellRenderer: numberFormatter
  },
];
